import * as api from '../api'
import { CREATE_ARTICLE, DELETE_ARTICLE, UPDATE_ARTICLE } from '../constants/actionTypes.js'

// Action creator
export const createArticle = (article, match) => async (dispatch, getState) => {
    try {
        
        const newArticle = article
        newArticle.creation = Date.now()
        newArticle.idMatch = match.idMatch ? match.idMatch : match.idActu

        if(newArticle.timer === undefined)
            newArticle.timer = (match.statusTimer === 'off' && !match.timer) || !match.timer ? 0 : (Math.floor(match.timer/60))*60
        if(newArticle.period === undefined)
        newArticle.period = match.period ? match.period : 0

        delete newArticle._id

        const formData = new FormData()
        Object.keys(newArticle).map(key => {
            if(newArticle[key] instanceof Array ){
                for (var i = 0; i < newArticle[key].length; i++) {
                    formData.append([key]+'[]', newArticle[key][i]);
                }
            }else{
                let noNull = newArticle[key] ?? ""
                formData.append(key, noNull)
            }
                
        })

        const { data } = await api.createArticle(formData)

        console.log('created article', data);

        return data;

        //dispatch( { type : CREATE_ARTICLE, payload: data })
    } catch(error){
        console.log(error)
        throw error;
    }
}

export const updateArticle = (articleDetail, id) => async (dispatch, getState) => {
    try {

        const formData = new FormData()
        Object.keys(articleDetail).map(key => {
            if(articleDetail[key] instanceof Array ){
                for (var i = 0; i < articleDetail[key].length; i++) {
                    formData.append([key]+'[]', articleDetail[key][i]);
                }
            }else{
                let noNull = articleDetail[key] ?? ""
                formData.append(key, noNull)
            }
                
        })

        const { data } = await api.updateArticle(id, formData)

        console.log('updated article', data);

        return data;

        //dispatch({ type : UPDATE_ARTICLE, payload: data})
    } catch(error){
        console.log(error)
        throw error;
    }
}

export const deleteArticle = (id) => async (dispatch) => {
    try {
        await api.deleteArticle(id)

        //dispatch({ type : DELETE_ARTICLE, payload: id})
    }catch(error){
        console.log(error)
        throw error;
    }
}